import script from "./ViewBudgetYearPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBudgetYearPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewBudgetYearPage.vue?vue&type=style&index=0&id=3d952363&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d952363"]])

export default __exports__